
angular.module('dyb.util.filters', [])

    .filter('ordinal', function() {
        return function(val) {
            if (val==11){
                return 'th';
            }
            else if (val==12){
                return 'th';
            }
            else if (val==13){
                return 'th';
            }
            else {
                switch (val % 10) {
                    case 1:
                        return 'st';
                    case 2:
                        return 'nd';
                    case 3:
                        return 'rd';
                    default:
                        return 'th';
                }
            }
        };
    })

    .filter('default', function() {
        return function(val, def) {
            return angular.isDefined(val) ? val : def;
        }
    })

    .filter('maxOf', function() {
        return function() {
            return Math.max.apply(Math, arguments);
        }
    })

    .filter('contains', function() {
        return function(array, value) {
            return angular.isArray(array) && array.indexOf(value) >= 0;
        };
    })

    .filter('isOneOf', function() {
        return function(value, array) {
            return array.indexOf(value) >= 0;
        };
    })

    .filter('exists', function() {
        return angular.isDefined;
    })

    .filter('existsAndIsNot', function() {
        return function(value, other) {
            return angular.isDefined(value) &&
                value !== null &&
                value !== other;
        };
    })

    .filter('between', function() {
        return function(value, lower, upper) {
            return value >= lower && value <= upper;
        };
    })

    .filter('parenthesis', function() {
        return function(contents) {
            if (!contents) { return ""; }
            else {return "(" + contents + ")";}
        };
    })

    .filter('postalCode', function() {
        return function(code) {
            return !code || code.length <= 5 ? code :
                code.substr(0, 5) + "+" + code.substr(5);
        }
    })

    .filter('markdown', function() {
        return function(content) {
            if (!content) { return undefined; }
            content = marked(content);
            content = angular.element(content);
            angular.forEach(content.find('a'), function(item) {
                item.setAttribute('target', '_blank');
            });
            return angular.element('<div></div>').append(content).html();
        };
    })

    .filter('arraySum', function() {
        return function(array) {
            return array.reduce(function(a, b) { return a + (b || 0); }, 0);
        }
    })

    .filter('percent', function() {
        return function(number) {
            if (!isNaN(number) && angular.isNumber(number)) {
                return (Math.round(number * 1000) / 10) + "%"
            }
        }
    })

    .filter('camelize', function() {
        return function(s) {
            if (!s) {
                return
            }
            s =  s.replace(/_([a-z])/g, function (g) {
                return g[1].toUpperCase();
            });
            s = s[0].toUpperCase() + s.substr(1);
            return s;
        };
    })

    .filter('simplePlural', function() {
        return function(string, count) {
            if (angular.isUndefined(count)) return string;
            else if (count === 1) return string.replace("(s)", "");
            else return string.replace("(s)", "s");
        };
    })

    .filter('units', function() {
        return function(count, units) {
            if (angular.isUndefined(count) || count === null) return '';
            else if (count === 1) return count.toString() + " " + units.replace("(s)", "");
            else return count.toString() + " " + units.replace("(s)", "s");
        }
    })

    .filter('studentCount', function() {
        return function(number, capitalize) {
            if (angular.isUndefined(number)) { return "" }
            return (number == 0 ? 'No' : number) +
                   (capitalize ? ' Student' : ' student') +
                   (number > 1 ? 's' : "s");
        }
    })

    .filter('programCount', function() {
        return function(number, capitalize) {
            if (angular.isUndefined(number)) { return "" }
            return (number == 0 ? 'No' : number) +
                   (capitalize ? ' Program' : ' program') +
                   (number > 1 ? 's' : "s");
        }
    });

